<template>
    <div v-if="brandWarning" class="brandWarning">
      <span >Please select a brand</span>
    </div>
</template>

<script>
export default {
  name: 'AppBrandWarning',
  data() {
    return {
      show: !document.cookie.split('; ').find(cookie => cookie.startsWith('tenant=')),
    };
  },
  computed: {
    brandWarning() {
      return !this.$store.state.brandSelected;
    }
  },
  watch: {
    brandWarning(newValue) {
      this.brandWarning = newValue;
    }
  }
};
</script>
